module.exports = __webpack_public_path__ + "img/accounting-icon.95566ec5.svg";